module.exports = __webpack_public_path__ + "img/right-arrow.95ad7891.svg";